/**
 * Single source of truth for which Pre-Meeting Brief flow the UI uses.
 *
 * Rolled back to "v1" (direct PMB v1 APIs via the drawer/modal — the
 * original pre-v2 flow) for ALL users on 2026-05-27. The v2 agent/overlay
 * components remain in the tree but are dormant; every ingress point routes
 * through this switch instead of branching on `enableAgentV2`.
 *
 * To re-enable the overlay everywhere, flip PMB_FLOW to "v2-overlay" — one
 * change, no per-file archaeology. (v2/agent is enabled for all tenants now,
 * so the overlay doesn't need the old enableAgentV2 fallback.)
 *
 * NOTE: the annotation `: PmbFlow` (union type, not the literal) is
 * deliberate — it keeps `isPmbV1` a `boolean` at the type level so the
 * v2 branches in each ingress point stay type-checked and lint-clean
 * rather than being flagged as unreachable/constant-condition.
 */
export type PmbFlow = "v1" | "v2-overlay"

export const PMB_FLOW: PmbFlow = "v1"

export const isPmbV1: boolean = PMB_FLOW === "v1"
